// extracted by mini-css-extract-plugin
module.exports = {"root":"SpaceSizeEdit__root___-ULW-","small":"SpaceSizeEdit__small___2JdZA","sizeDropdown":"SpaceSizeEdit__sizeDropdown___2tWHr"};